export const pageurl = {
	OVERVIEW: '/',
	AGENTAPPLICATION: '/application',
	APPLICATIONSUCCESS: '/application/success',
	INSTRUCTIONS: '/instructions',
	// Public, single-use invitee page for the trusted-agent invitation link.
	TRUSTED_AGENT_REGISTER: '/trusted-agent/register/:token',
};

// Builds the concrete invitee URL for a token (the route above is the pattern).
export const trustedAgentRegisterPath = (token: string): string =>
	pageurl.TRUSTED_AGENT_REGISTER.replace(':token', encodeURIComponent(token));
